
<p-dialog [(visible)]="showPopup" [resizable]="false" appendTo="body" [modal]="true"
  [breakpoints]="{'767px': '100vw'}" [style]="{width: '520px'}" styleClass="no-header-modal">

  <ng-template pTemplate="header" styleClass="hidden"></ng-template>
  <ng-template pTemplate="content" styleClass="p-0">

    <!-- Header -->
<div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300">
    <h2 class="mb-0 text-sm">{{ 'AUTOMATION.CREATE.ASSO_STAFF' | translate }}</h2>
    <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopup()"></i>
  </div>
  <!-- Header -->

  <!-- Message -->
  <div class="-my-3" *ngIf="false">
      <p-message severity="info" icon="fa fa-info-circle" aria-label="notification-setting-message">
        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s
      </p-message>
    </div>
    <!-- Message -->
    <form [formGroup]="staffNotificationForm">
    <!-- Content -->
    <div class="surface-200 p-3 pb-6">
  
      <h6 class="font-medium text-700 text-xs block mb-0 uppercase">{{ 'AUTOMATION.CREATE.SEND_NOTI_TO' | translate }}</h6>

      <!-- Cards List -->
      <ul class="list-none p-0 mn-0 text-sm">
      
      <!-- Card -->
      <li [ngClass]="associatedStaffCheck ? 'border-primary' : 'border-300' " class="surface-0 border-round shadow-1 p-3 border-2 mt-3 flex align-items-center">
      <p-checkbox checkboxIcon="fa fa-check" formControlName="notify_record_associated_staff" [binary]="true" [(ngModel)]="associatedStaffCheck" (change)="associatedStaffCheck=!associatedStaffCheck"></p-checkbox>
      <div class="ml-3">
      <strong [ngClass]="associatedStaffCheck ? 'text-primary' : '' " class="block mb-2">{{ 'AUTOMATION.CREATE.ASSO_STAFF' | translate }}</strong>
       <p *ngIf="modelData.automationMaster!.associatedStaffId" class="mb-0 text-xs text-600">{{ 'AUTOMATION.CREATE.STAFF_ASSO_MSG' | translate }} {{ 'AUTOMATION.STAFF.'+modelData.automationMaster!.associatedStaffId.split(".")[1] | translate }}</p>
      </div>
      </li>
      <!-- Card -->

      <!-- Card -->
      <li *ngIf="false" [ngClass]="otherStaffCheck ? 'border-primary' : 'border-300' " class="surface-0 border-round shadow-1 p-3 border-2 mt-3 flex align-items-center">
          <p-checkbox checkboxIcon="fa fa-check" formControlName="notify_record_other_staff" [binary]="true" [(ngModel)]="otherStaffCheck" (change)="otherStaffCheck=!otherStaffCheck"></p-checkbox>
          <div class="ml-3">
          <strong [ngClass]="otherStaffCheck ? 'text-primary' : '' " class="block mb-2">Add Other Staffs</strong>
          <p class="mb-0 text-xs text-600">Lorem Ipsum is simply dummy text of the printing and typesetting Lorem Ipsum is simply dummy text of the printing and typesetting</p>
          </div>
      </li>
      <!-- Card -->

      </ul>
      <!-- Cards List -->

      <div class="mt-4" *ngIf="otherStaffCheck">
        <label class="font-medium text-700 text-xs mb-2 block white-space-nowrap">SEARCH STAFF AND ADD</label>
        <p-multiSelect styleClass="w-full text-sm" [options]="accessedStaffs" formControlName="notify_additional_staff_to"
        [defaultLabel]="'ADMIN.COMMON.SELECT' | translate" optionLabel="name">
        <ng-template let-staff pTemplate="item">
          <div class="flex align-items-center justify-content-between">
            <div class="flex align-items-center">
              <div class="relative mr-2">
                <p-avatar *ngIf="staff.ff_picture" image="{{staff.ff_picture}}" styleClass="block" shape="circle">
                </p-avatar>
                <p-avatar *ngIf="!staff.ff_picture" [label]="staff.name | titlecase | shortName" shape="circle"></p-avatar>
              </div>
              <div class="text-sm ml-2">{{staff.name}}</div>
            </div>
          </div>
        </ng-template>
      </p-multiSelect>
      </div>

    </div>
    <!-- Content -->
    </form>

  <!-- Footer -->
  <div class="p-3 flex justify-content-between align-items-center border-top-1 border-300">
    <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" styleClass="p-button-text text-sm" (click)="closePopup()"></p-button>
    <button pButton pRipple type="button" [label]="'AUTOMATION.CREATE.BTN_SAVE_SETING'| translate " [disabled]="!staffNotificationForm.valid || !SelectedAssociatedStaffFormControl.value" class="text-sm" (click)="SelectNotificationSetting()"></button>

  </div>
  <!-- Footer -->
</ng-template>

</p-dialog>
<!-- Staff Notification Settings Modal -->